<evsb-standard-modal-window [fullHeight]="true">
    <header>
      <evsb-modal-header
        [backLabel]="'modules.evsb.navigation.back' | translate"
        [backEnabled]="canGoBack"
        (back)="goBack()"
      >
        {{ 'modules.evsb.chargingStation.title' | translate }}
      </evsb-modal-header>
    </header>
  
    <div class="overflow-y-auto">
      <evsb-slide-card
        [title]="model.title | translate"
        [src]="model.src"
        [text]="model.text | translate"
        class="block pt-16 px-8 md:px-16"
      ></evsb-slide-card>
      <div class="p-8 md:px-16 text-center">
        <div class="w-full flex flex-col gap-5">
          <evsb-primary-button [fullWidth]="true" (click)="navigateToForm()">
            {{ 'modules.evsb.chargingStation.outbound.info.cta' | translate }}
          </evsb-primary-button>
          <evsb-link-button [fullWidth]="true" (click)="goBack()">
            {{ 'modules.evsb.chargingStation.outbound.info.link' | translate }}
          </evsb-link-button>
        </div>
      </div>
    </div>
  </evsb-standard-modal-window>
  